<template>
  <div class="datepicker">
    <!-- Native Datepicker -->
    <b-form-input
      v-if="supported"
      type="date"
      :id="id"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      v-model="date">
    </b-form-input>
    <!-- / Native Datepicker -->

    <!-- Fallback -->
    <b-input-group v-else>
      <!-- Picker -->
      <datetime
        input-class="form-control"
        format="MM/dd/yyyy"
        type="date"
        placeholder="mm/dd/yyyy"
        auto
        :input-id="id"
        :readonly="readonly"
        :disabled="disabled"
        :phrases="{ok: 'OK', cancel: 'Cancel'}"
        :minute-step="5"
        v-model="date">
      </datetime>
      <!-- / Picker -->
    </b-input-group>
    <!-- / Fallback -->
  </div>
</template>

<script>
const isDateSupported = () => {
  const $input = document.createElement('input');
  const value = 'a';
  $input.setAttribute('type', 'date');
  $input.setAttribute('value', value);
  return $input.value !== value;
};

export default {
  name: 'datepicker',
  props: [
    'value',
    'id',
    'name',
    'readonly',
    'disabled',
  ],
  data() {
    return {
      supported: isDateSupported(),
      date: '',
    };
  },
  watch: {
    date(value) {
      let v = value;

      if (value) {
        v = value.slice(0, 19);
      }

      this.$emit('input', v);
    },
    value(value) {
      this.date = value;
    },
  },
  created() {
    this.date = this.value;
  },
};
</script>

<style lang="scss">
.datepicker {
  .vdatetime {
    width: 100%;
  }
}
</style>
